<template>
  <div>
    <div class="top-block">
      <VanImage class="top-decor-img" :src="check_top_decor" :width="transPxToRem(375)" :height="transPxToRem(200)" />
      <VanImage class="status-img" :src="statusImg" :width="transPxToRem(80)" :height="transPxToRem(80)" />
      <div class="top-block-text">
        <div class="status-text">{{ checkInfo.prepareStatusTxt }}</div>
        <div class="check-date">考核日期{{ checkInfo.checkTime }}</div>
      </div>
    </div>
    <div class="van-hairline--bottom"></div>
    <div class="content-block">
      <div :class="`content-box content-${fIndex + 1}`" v-for="(fItem, fIndex) in contentColum" :key="fIndex">
        <div class="content-head" v-if="fIndex === 0">
          <van-image :src="checkInfo.avatar" :width="transPxToRem(48)" :height="transPxToRem(48)" round />
          <div class="content-right">
            <div class="name-box">
              <span class="name">{{ checkInfo.name }}</span>
              <span>（ID：{{ checkInfo.puid }}）</span>
            </div>
            <div class="mobile-box">
              {{ checkInfo.mobile }}
            </div>
          </div>
        </div>
        <van-cell-group :border="false" class="check-content">
          <template v-for="(item, index) in fItem" :key="index">
            <van-cell
              :border="false"
              :title-style="{ color: '#999' }"
              value-class="check-content-value"
              :title="item.title"
            >
              <template #value>
                <template v-if="item.key == 'certificatePhotos'">
                  <template v-if="checkInfo.certificatePhotos.length > 0">
                    <VanImage
                      style="margin-left: 5px"
                      v-for="(subItem, subIndex) in checkInfo.certificatePhotos"
                      :key="subIndex"
                      :src="subItem"
                      @click="ImagePreview(checkInfo.certificatePhotos)"
                      :width="transPxToRem(40)"
                      :height="transPxToRem(25)"
                    />
                  </template>
                </template>
                <span v-else>{{ checkInfo[item.key] }}</span>
              </template>
            </van-cell>
          </template>
        </van-cell-group>
      </div>
      <div class="content-box">
        <div class="content-title">用户动态</div>
        <div class="dynamic-box">
          <div class="dynamic-item" v-for="(item, index) in checkInfo.result" :key="index">
            <div class="dynamic-item-left">
              <i class="circle-icon"></i>
              <div class="vertical-line" v-if="index !== checkInfo.result.length - 1"></div>
            </div>
            <div class="dynamic-item-right">
              <div class="dynamic-title">{{ item.title }}</div>
              <div class="dynamic-des">
                <div>
                  {{ `${index === 0 ? '申请' : '审核'}人：${item.auditInfo}` }}
                </div>
                <div class="dynamic-time">{{ `${index === 0 ? '申请' : '审核'}时间：${item.auditTime}` }}</div>
                <div>{{ `备注：${item.remark}` }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, ref, onMounted } from 'vue'
import { transPxToRem } from '@/utils'
import { useCssVar } from '@vueuse/core'
import { Image as VanImage, ImagePreview } from 'vant'
// import { getLocal } from '@/common/js/utils'
// import { useUserStore } from '@/store/user'
import { getAgentJoinDetailById } from '@/api/quasiAgentCheck'
import { useAgentLevel } from '@/hooks/useBusiness'
import { useRoute } from 'vue-router'
import { checkTypeEnum } from './check.data'
import check_top_decor from '@/assets/img/check_top_decor.png'
import checkIng from '@/assets/img/check_ing.png'
import manualCheck from '@/assets/img/manual_check.png'
import hasStandard from '@/assets/img/has_standard.png'
import notStandard from '@/assets/img/not_standard.png'

const {
  query: { joinId }
} = useRoute()

const checkInfo = ref({
  certificatePhotos: [],
  result: [],
  prepareStatus: checkTypeEnum.LOADING
})
const status = ref(0)
const statusImgsObj = {
  0: checkIng,
  1: hasStandard,
  2: notStandard,
  3: manualCheck
}
const statusImg = computed(() => statusImgsObj[status.value])
const primaryColor = useCssVar('--van-primary-color', document.documentElement)

const { quasiAgentList, agentLevelList } = useAgentLevel()
const getCheckInfo = async () => {
  try {
    const resData = await getAgentJoinDetailById({ joinId })
    const agentList = [checkTypeEnum.HAS_STANDARD, checkTypeEnum.MANUAL].includes(resData.prepareStatus)
      ? agentLevelList.value
      : quasiAgentList.value
    if (resData) {
      checkInfo.value = {
        ...resData,
        userType: agentList.filter(d => d.value == resData.agentLevel)[0].label
      }
    }
  } catch (e) {
    console.error(e)
  }
}

const isCheckIng = computed(() => checkInfo.value.prepareStatus === checkTypeEnum.LOADING)

const isStand = computed(() =>
  [checkTypeEnum.HAS_STANDARD, checkTypeEnum.MANUAL].includes(checkInfo.value.prepareStatus)
)

const contentColum1 = [
  {
    key: 'applyTime',
    title: '注册时间'
  },
  {
    key: 'userType',
    title: '用户类型'
  },
  {
    key: 'inviter',
    title: '推荐人'
  },
  {
    key: 'parent',
    title: '直属上级'
  },
  {
    key: 'peerInviter',
    title: '同级推荐人'
  }
]

const contentColum2 = computed(() =>
  [
    {
      key: 'prepareStart',
      title: '考核开始'
    },
    {
      key: 'prepareTime',
      title: '考核结束'
    },
    {
      key: 'checkTime',
      title: '授权时间'
    },
    {
      key: 'prepareStandTxt',
      title: '考核标准'
    },
    {
      key: 'prepareActualTxt',
      title: '实际情况'
    },
    {
      key: 'distanceStandTxt',
      title: '距离标准'
    },
    {
      key: 'prepareStatusTxt',
      title: '考核结果'
    }
  ]
    .filter(d => !(['prepareTime', 'checkTime'].includes(d.key) && isCheckIng.value))
    .filter(d => !(['distanceStandTxt'].includes(d.key) && isStand.value))
)

const contentColum3 = [
  {
    key: 'area',
    title: '所在地区'
  },
  {
    key: 'certificatePhotos',
    title: '身份证明'
  },
  {
    key: 'wxNo',
    title: '微信号'
  }
]

const contentColum = computed(() => [contentColum1, contentColum2.value, contentColum3])
// const userStore = useUserStore()
// const theme = computed(() => userStore.getTheme)

onMounted(() => {
  getCheckInfo()
  // primaryColor.value = theme.value.PrimaryButtonColor
})
</script>
<style lang="less" scoped>
.top-block {
  position: relative;
  height: 200px;
  background-color: v-bind(primaryColor);
  .top-decor-img {
    position: absolute;
    top: 0;
    left: 0;
  }
  .status-img {
    position: absolute;
    top: 24px;
    right: 20px;
  }
  .top-block-text {
    color: #fff;
    position: absolute;
    top: 40px;
    left: 12px;
    .status-text {
      font-size: 20px;
      font-weight: 500;
    }
    .check-date {
      margin-top: 5px;
      font-weight: 400;
    }
  }
}
.content-block {
  padding: 0 12px;
  position: relative;
  top: -80px;
  .content-box {
    padding: 16px 12px;
    background-color: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    .content-head {
      display: flex;
      align-items: center;
      padding-bottom: 15px;
      margin-bottom: 15px;
      // border-bottom:1px solid #DBDBDB ;
      .content-right {
        margin-left: 12px;
        font-size: 14px;
        .name-box {
          .name {
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 5px;
          }
        }
      }
    }
    .content-title {
      font-size: 16px;
    }
    .dynamic-box {
      margin-top: 15px;
      .dynamic-item {
        display: flex;
        // height: 65px;
        .dynamic-item-left {
          position: relative;
          padding-top: 5px;
          .circle-icon {
            display: block;
            border-radius: 50%;
            width: 12px;
            height: 12px;
            box-shadow: 0px 1px 3px 0px rgba(255, 96, 96, 0.3);
            border: 3px solid v-bind(primaryColor);
            position: relative;
            z-index: 1;
            background-color: #fff;
          }
          .vertical-line {
            position: absolute;
            left: 5px;
            top: 17px;
            width: 1px;
            height: 70px;
            background: v-bind(primaryColor);
          }
        }
        .dynamic-item-right {
          margin-left: 16px;
          .dynamic-title {
            font-weight: 500;
            font-size: 14px;
            color: var(--van-black-2);
          }
          .dynamic-des {
            padding-bottom: 10px;
            color: var(--van-black-9);
          }
          .dynamic-time {
            font-weight: 400;
            // margin-top: 5px;
            color: var(--van-black-9);
          }
        }
      }
    }
  }
  .content-1 {
    background: url('../../assets/img/check_bg.png') no-repeat;
    background-size: cover;
  }
  .check-content {
    .van-cell {
      padding: 0 0 5px 0;
      justify-content: space-between;
      :deep(.van-cell__value) {
        flex: 3;
        color: #222;
      }
    }
  }
}
</style>
